/*
  Motureo („pazur” 19.10): licznik do końca promocji i chowanie plakietek po terminie (snippets/motureo-promo.liquid).
  Koniec podaje serwer w data-promo-end (sekundy od 1970, ta sama chwila co koniec rabatu w sklepie). Skrypt odlicza
  co sekundę i po terminie usuwa licznik i plakietki — także na stronie z pamięci podręcznej. Bez zależności;
  ładowany wiele razy (z każdej karty) inicjuje się raz. Czas w czytniku ekranu nie jest ogłaszany co sekundę
  (brak aria-live), tekst ma etykietę na elemencie <time>.
*/
(function () {
  if (window.motureoPromo) return;
  window.motureoPromo = true;

  var pad = function (n) {
    return n < 10 ? '0' + n : String(n);
  };

  var timer = null;

  function tick() {
    var now = Date.now() / 1000;
    var items = document.querySelectorAll('[data-promo-end]');
    if (!items.length && timer) {
      clearInterval(timer);
      return;
    }
    items.forEach(function (el) {
      var end = Number(el.getAttribute('data-promo-end'));
      if (!end || now >= end) {
        el.remove();
        return;
      }
      var time = el.querySelector('[data-promo-time]');
      if (!time) return;
      var left = Math.floor(end - now);
      var days = Math.floor(left / 86400);
      var h = Math.floor((left % 86400) / 3600);
      var m = Math.floor((left % 3600) / 60);
      var s = left % 60;
      time.textContent = days + ' ' + (el.getAttribute('data-promo-days') || '') + ' ' + pad(h) + ':' + pad(m) + ':' + pad(s);
    });
  }

  function start() {
    tick();
    timer = setInterval(tick, 1000);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
